import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import $ from "jquery";
import {FormattedMessage, injectIntl} from "react-intl";

import SelectionMobileViewSwitchers from '../mobile/selectionMobileViewSwitchers';
import FeatureWizardSteps from './featureWizardSteps';
import FeatureWizardBody from './featureWizardBody';
import UserLoginButton from './../../../ui/userLoginButton';
import BodyPanel from "../desktop/bodyPanel";
import ActionTypes from "../../../../misc/actionTypes";
import {NotQCVanityDoorStylesFilters} from "../../../bvComponent/core/constants";
import {UserPopupTypes} from "../../constants";

class FeatureWizard extends Component {

  static propTypes = {
    features: PropTypes.array.isRequired,
    exitFeatureWizard: PropTypes.func.isRequired,
    handleNavigationItemClick: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
    wizardGroups: PropTypes.array.isRequired,
    setWizardGroups: PropTypes.func.isRequired,
    changeMessageBoxState: PropTypes.func.isRequired,
    setWizardLockedItem: PropTypes.func,
    isPhoneNumberValidated: PropTypes.bool,
    userIsLoggedIn: PropTypes.bool,
    toggleUserPopup: PropTypes.func,
    searchText: PropTypes.string,
    // bodyPanelNeededProps
    activePart: PropTypes.object,
    activeSubPart: PropTypes.object,
    toggleApplyWallsCheckbox: PropTypes.func,
    isWallItem: PropTypes.func,
    handleSubTypeClick: PropTypes.func,
    getFilterDisplayName: PropTypes.func,
    showerWallWizardGroupsSelected: PropTypes.bool,
    toggleWizardFilterSelection: PropTypes.func,
    handleSearchInputChange: PropTypes.func,
    // bodyPanelNeededProps end
  };

  constructor(props) {
    super(props);
    window.itemClickCount = window.itemClickCount || 0;
    window.allowClickLeadCapturePopup = true;
    this.state = {
      availableSteps: [],
      defaultSteps: [],
      featureWizardStep: 0,
      showMobileGroups: false,
      mounted: false,
      finishClicked: true,
      filteredFeatures: [],
      reload: false,
      stepsPartId: null // partId the current availableSteps were built for
    };
  }

  componentDidMount() {
    this.initWizardSteps();
    $(document).on(ActionTypes.USER_IS_LOGGED_IN, this.userHasLoggedIn);
  }

  initWizardSteps = () => {
    let availableSteps = [];
    // const fabricatorSettings = this.props.fabricatorData.settings;
    const stepsPartId = this.props.activeSubPart.partId;
    // the parent navigation should only mount the wizard for parts with wizard groups (getWizardGroupsForPartId)
    let wizardGroups = this.props.wizardGroups;
    if (!Array.isArray(wizardGroups)) {
      console.warn("FeatureWizard: no wizard groups for partId", stepsPartId);
      wizardGroups = [];
    }
    const filteredFeatures = this.getFilteredFeatures();
    const itemIsSelected = this.activeItemIsSelected();

    filteredFeatures.forEach((feature) => {
      wizardGroups.forEach((wizardGroup) => {
        // console.log('wizardGroup', wizardGroup);
        const filter = this.props.filterGroups.find(filterGroup => filterGroup.name.trim() === wizardGroup.filterName);
        if (filter) {
          const filterId = filter.id;

          let currentFilter = availableSteps.find(step => step.filterName === wizardGroup.filterName);
          if (!currentFilter) {
            currentFilter = {
              filterName: wizardGroup.filterName,
              values: wizardGroup.values || [],
              id: filterId,
              selectedValueId: wizardGroup.selectedValueId,
              selectedValueName: wizardGroup.selectedValueName,
              hidden: this.checkStepForHidden(filter.name),
              hasValues: false
            };
            availableSteps.push(currentFilter);
          }

          const sizeIds = feature.dbFeature.filterValueIDs[filterId];
          if (sizeIds) {
            if (!currentFilter.hasValues) {
              currentFilter.hasValues = true;
            }
            sizeIds.forEach(filterValue => {
              const filterValueExist = currentFilter.values.find(wizardValueObject => +wizardValueObject.filterValue === +filterValue);
              if (!filterValueExist) {
                let doNotPush = false;
                if (currentFilter.filterName === "DoorStyle" || currentFilter.filterName === "Material") {
                  const fValue = filter.values.find(val => val.id === filterValue);
                  if (fValue) {
                    if (fValue.value === "QC Hermosa" || (fValue.value === "Slab" && this.props.fabricatorData.isRebath)) {
                      doNotPush = true
                    }
                  }
                }
                if (!doNotPush) {
                  currentFilter.values.push({
                    selectionAvailable: true,
                    filterValue
                  })
                }
              }
            });
          }
        }
      });
    });

    availableSteps = availableSteps.filter(currentFilter => currentFilter.hasValues); // we might have no filter values

    const allStepsCompleted = availableSteps.every(step => step.selectedValueId);
    if (itemIsSelected && this.props.activeSubPart.activeFeature) { // set active filters from the active item
      // if (this.props.activeSubPart.activeFeature && this.props.activeSubPart.firstClick[this.props.activeQuoteIndex] && this.props.activeSubPart.placeholderChanged) {
      const currentActiveFilters = this.props.activeSubPart.activeFeature.dbFeature.filterValueIDs;
      availableSteps = availableSteps.map(step => {
        const filterGroup = this.props.filterGroups.find(filterGroup => {
          return filterGroup.id === step.id
        });
        let filterGroupValue = {};
        if (currentActiveFilters[step.id]) {
          const selectedFilterValueId = currentActiveFilters[step.id][0];
          filterGroupValue = filterGroup && filterGroup.values.find(filterGroupValue => {
            return filterGroupValue.id === selectedFilterValueId
          });
        }
        if (filterGroupValue) {
          step.selectedValueName = filterGroupValue.displayText;
          step.selectedValueId = filterGroupValue.id;
        }
        step.selectedItemIsLocked = this.getLockedPropertyValueObjectById(filterGroupValue, filterGroupValue.id, step.id, filteredFeatures);
        return step
      })
    }

    this.setState({
      filteredFeatures,
      stepsPartId,
      defaultSteps: availableSteps.map(a => Object.assign({}, a)),  // they need to be different
      availableSteps: availableSteps.map(b => Object.assign({}, b)),
      // showMobileGroups: allStepsCompleted,
      featureWizardStep: this.props.wizardStepIndex <= availableSteps.filter(step => !step.hidden).length - 1 ? this.props.wizardStepIndex : 0,
      finishClicked: allStepsCompleted
    }, () => {
      if (this.activeItemIsSelected()) {
        this.updateStepValues(availableSteps);
      }
      this.setLockedView();
      setTimeout(() => {
        this.setState({
          mounted: true
        });
      }, 0)
    });
  };

  componentWillUnmount = () => {
    // persist under the partId the steps were built for, not whatever activeSubPart is now
    if (this.state.stepsPartId) {
      this.props.setWizardGroups(this.state.availableSteps, this.state.stepsPartId);
    }
    $(document).off(ActionTypes.USER_IS_LOGGED_IN, this.userHasLoggedIn);
  };

  componentDidUpdate(prevProps) {
    // Switching between wizard parts (e.g. vanity -> shower) keeps this instance mounted.
    // Done here (not in componentWillReceiveProps) so the rebuild reads the NEW props.
    const prevPartId = prevProps.activeSubPart && prevProps.activeSubPart.partId;
    const partId = this.props.activeSubPart && this.props.activeSubPart.partId;
    if (prevPartId && partId && prevPartId !== partId) {
      if (this.state.stepsPartId) { // keep the previous part's selections
        this.props.setWizardGroups(this.state.availableSteps, this.state.stepsPartId);
      }
      this.initWizardSteps();
    }
  }

  updateStepValues = (availableSteps = this.state.availableSteps, forceClick = false) => {
    this.setState({
      reload: forceClick,
      availableSteps: availableSteps.map((step, stepIndex) => {
        step.values = this.setStepValues(step, stepIndex);
        return step
      })
    }, () => {
      if (forceClick) {
        this.setState({
          reload: false
        })
      }
    })
  };

  getFilteredFeatures = () => {
    const activePart = this.props.activeSubPart;
    if (activePart.partId === "shower_interior_wall") {
      return activePart.navigationSubItemsWithFilterMultipleConditions(activePart.getArrayOfConditions())
    }
    return this.props.features.filter(feature => {
      return !feature.dbFeature.displayName.includes("Hermosa")
    })
  };

  getLockedPropertyValueObjectById = (currentFilterValue, filterValueId, stepId, filteredFeatures = this.state.filteredFeatures) => {
    const fabricatorSettings = this.props.fabricatorData.settings;
    filteredFeatures = filteredFeatures.filter(feature => {
      return !feature.dbFeature.displayName.includes("laceholder")
    });
    let itemIsLocked = false;
    if (fabricatorSettings.leadCapture && !this.props.isPhoneNumberValidated && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) {
      if (currentFilterValue.lockedInWizard || !filteredFeatures.some(feature => {
          // console.log('bject.keys(feature.dbFeature.filterValueIDs)', Object.keys(feature.dbFeature.filterValueIDs));
          const filterToFind = feature.dbFeature.filterValueIDs[stepId];
          return filterToFind && filterToFind.includes(filterValueId) && feature.dbFeature.unlocked;
        })) {
        itemIsLocked = true
      }
    }
    return itemIsLocked
  };

  userHasLoggedIn = () => {
    const currentStep = this.state.availableSteps.filter(step => !step.hidden)[this.state.featureWizardStep];
    if (currentStep.selectedValueId) {
      const selectedValue = currentStep.values.find(val => val.filterValue === currentStep.selectedValueId);
      if (selectedValue) {  // just in case, we might remove this check
        this[selectedValue.selectionAvailable ? "onItemClick" : "onItemClickDisabled"](
          {
            id:currentStep.selectedValueId,
            value: currentStep.selectedValueName,
            displayText: currentStep.selectedValueName
          },
          false,
          currentStep.filterName
        )
      }
    }
  };

  activeItemIsSelected = () => {
    const fabricatorSettings = this.props.fabricatorData.settings;
    const activeSubPart = this.props.activeSubPart;
    return (!fabricatorSettings.leadCapture
      || (activeSubPart.activeFeature && !activeSubPart.activeFeature.partName.includes("WizardPlaceholder")
        && activeSubPart.firstClick[this.props.activeQuoteIndex] && activeSubPart.placeholderChanged));
  };

  checkStepForHidden = (filterGroupName) => {
    let hidden = false;
    filterGroupName =  filterGroupName.trim().toLowerCase();
    if (this.activeItemIsSelected() && this.props.activeSubPart.activeFeature) {

      const currentActiveFilters = this.props.activeSubPart.activeFeature.dbFeature.filterValueIDs;

      if (this.props.activeSubPart.partId === "shower_interior_wall") {
        const materialFilter = this.props.filterGroups.find(filterGroup => filterGroup.name.trim() === "Material");
        if (materialFilter && currentActiveFilters[materialFilter.id]) { // check for existing BV filters
          const materialValueId = currentActiveFilters[materialFilter.id][0];
          const materialValue = materialFilter.values.find(val => val.id === materialValueId);
          if (materialValue && (
              (materialValue.value !== "DuraBath" && filterGroupName === "durabathcolor")
              || (materialValue.value !== "DuraBath" && materialValue.value !== "Tile" && filterGroupName === "tilepattern")
              || (materialValue.value !== "Acrylic" && filterGroupName === "acrylicpattern")
              || (materialValue.value !== "Acrylic" && filterGroupName === "acryliccolor")
              || (materialValue.value !== "Tile" && filterGroupName === "tilecolor")
              || (materialValue.value !== "Slab" && materialValue.value !== "DuraBath Natural Stone" && filterGroupName === "slabcolor")
            )) {
            hidden = true;
          }
        }
      } else if (this.props.activeSubPart.partId === "vanity_cabinet") {
        const doorStyleFilter = this.props.filterGroups.find(filterGroup => filterGroup.name.trim() === "DoorStyle");
        if (doorStyleFilter && currentActiveFilters[doorStyleFilter.id]) { // check for existing BV filters
          const doorStyleValueId = currentActiveFilters[doorStyleFilter.id][0];
          const doorStyleValue = doorStyleFilter.values.find(val => val.id === doorStyleValueId);
          if (doorStyleValue && (
              (!NotQCVanityDoorStylesFilters.includes(doorStyleValue.value) && filterGroupName === "material")
            )) {
            hidden = true;
          }
        }
      }
    } else if (this.props.activeSubPart.partId === "shower_interior_wall") {
      const wizardFilters = ["slabcolor", "tilecolor", "tilepattern", "acrylicpattern", "acryliccolor"];
      hidden = wizardFilters.includes(filterGroupName);
    } else if (this.props.activeSubPart.partId === "vanity_cabinet") {
      hidden = filterGroupName === "material"
    }
    return hidden
  };

  setLockedView = () => {

    const fabricatorSettings = this.props.fabricatorData.settings;

    const currentStep = this.state.availableSteps.filter(step => !step.hidden)[this.state.featureWizardStep];
    if (currentStep && currentStep.selectedValueId && fabricatorSettings.leadCapture && !this.props.isPhoneNumberValidated) {
      const currentGroup = this.props.filterGroups.find((filterGroup) => {
        return filterGroup.id === currentStep.id
      });
      const currentFilterValue = currentGroup.values.find(currentGroupValue => {
        return currentGroupValue.id === currentStep.selectedValueId
      });
      const filteredFeatures = this.state.filteredFeatures.filter(feature => {
        return !feature.dbFeature.displayName.includes("laceholder")
      });

      let itemIsLocked = false;
      if (currentFilterValue.lockedInWizard || !filteredFeatures.some(feature => {
          // console.log('bject.keys(feature.dbFeature.filterValueIDs)', Object.keys(feature.dbFeature.filterValueIDs));
          const filterToFind = feature.dbFeature.filterValueIDs[currentStep.id];
          return filterToFind && filterToFind.includes(currentStep.selectedValueId) && feature.dbFeature.unlocked;
        })) {
        itemIsLocked = true
      }

      this.props.setWizardLockedItem(itemIsLocked);
    }
  };

  // getCurrentFilterObject = (stepIndex) => {
  getCurrentFilterObject = () => {
    const selectedFilterObject = {};
    // const availableSteps = (stepIndex || stepIndex === 0)
    //   ? this.state.availableSteps.slice(0, stepIndex) // we need to get only previous selected values if index is passed
    //   : this.state.availableSteps;
    this.state.availableSteps.filter(step => !step.hidden).forEach((availableStep) => {
      if (availableStep.selectedValueId) {
        selectedFilterObject[availableStep.id] = availableStep.selectedValueId
      }
    });
    return selectedFilterObject
  };

  setFeatureWizardStep = (featureWizardStep) => {
    const availableSteps = !featureWizardStep && !this.state.availableSteps[0].selectedValueId
      ? this.state.defaultSteps
      : this.state.availableSteps.map((availableStep, index) => {
        availableStep.values = this.setStepValues(availableStep, index);
        return availableStep
      });
    this.setState({
      featureWizardStep: availableSteps.filter(step => !step.hidden)[featureWizardStep] ? featureWizardStep : 0,
      showMobileGroups: false,
      availableSteps
    }, () => {
      this.setLockedView();
    });
    this.props.handleSearchInputChange({target: {value: ''}});
  };

  setStepValues = (step, stepIndex) => {
    const selectedFilterObject = this.getCurrentFilterObject(stepIndex);  // get only previous selected values
    // console.log('selectedFilterObject111', selectedFilterObject);
    return this.state.defaultSteps[stepIndex].values.map((wizardValueObject) => {
      let allFiltersObject = Object.assign({}, selectedFilterObject);

      // if (this.props.activeSubPart.partId === "vanity_cabinet" && step.filterName === "Color" && selectedFilterObject) {
      //   const doorStyleFilter = this.props.filterGroups.find(filterGroup => filterGroup.name.trim() === "DoorStyle");
      //   if (doorStyleFilter && selectedFilterObject[doorStyleFilter.id] === 661) {
      //     selectedFilterObject[doorStyleFilter.id] = 660  // TODO[Artem] REMOVE THIS HARDCODE (QC HERMOZA HAS WRONG FILTER ID!)
      //   }
      // }

      allFiltersObject[step.id] = +wizardValueObject.filterValue;
      // console.log('allFiltersObject', allFiltersObject);
      wizardValueObject.selectionAvailable = this.state.filteredFeatures.some(feature => {
        const featureFilters = feature.dbFeature.filterValueIDs;
        if (featureFilters && Object.keys(allFiltersObject).every((filterKey) => {
            return featureFilters[filterKey] && featureFilters[filterKey].includes(allFiltersObject[filterKey])
          })) {
          // console.log('feature', feature);
          return true
        }
        return false
      });
      return wizardValueObject
    });
  };

  getFilterValue = (step, filterValue) => {
    const filterGroup = this.props.filterGroups.find(filterGroup => {
      return filterGroup.id === this.state.availableSteps.filter(step => !step.hidden)[step].id
    });
    const filterGroupValue = filterGroup && filterGroup.values.find(filterGroupValue => {
      return filterGroupValue.id === +filterValue.id
    });
    return filterGroupValue
  };

  onItemClick = (filterValue, itemIsLocked, currentStepFilterName, forceClick = false) => {

    const fabricatorSettings = this.props.fabricatorData.settings;
    if( !this.props.userIsLoggedIn && fabricatorSettings.clickLeadCapture
      && ++window.itemClickCount >= fabricatorSettings.clickLeadCount && window.allowClickLeadCapturePopup) {
      this.handleUserLoginClick(UserPopupTypes.NewDesign);
      return;
    }

    let resetStepValues = false;
    if (this.props.activeSubPart.partId === "vanity_cabinet" && (currentStepFilterName === "Size") && !itemIsLocked) {
      resetStepValues = true
    }

    /*** 1) just set new filter value ***/
    const availableSteps = this.state.availableSteps.map((availableStep) => {
      if (availableStep.filterName === currentStepFilterName) {
        availableStep.selectedValueId = filterValue.id;
        const filterGroupValue = this.getFilterValue(this.state.featureWizardStep, filterValue);
        availableStep.selectedValueName = filterGroupValue ? filterGroupValue.displayText : "";
        availableStep.selectedItemIsLocked = itemIsLocked;
      }
      /*** 2) add for filter steps hidden values & clear selected values ***/
      availableStep = this.setHiddenStateToStep(availableStep, currentStepFilterName, filterValue, forceClick || resetStepValues);
      // if (availableStep.needToRefresh) {
      //   forceReload = true;
      //   delete availableStep.needToRefresh
      // }
      return availableStep
    });

    /*** 3) if it is SelectionNotAvailableClick & clicked on a DoorStyle - check if current Vanity support it ***/
    if (this.props.activeSubPart.partId === "vanity_cabinet" && forceClick && currentStepFilterName === "DoorStyle") {

      const sizeStep = this.state.availableSteps.find(step => step.filterName === "Size");
      const doorStyleStep = this.state.availableSteps.find(step => step.filterName === currentStepFilterName);

      let existingIdeallyFeature = this.state.filteredFeatures.find(feature => {
        const doorStyleMatch = feature.dbFeature.filterValueIDs[doorStyleStep.id]
          && feature.dbFeature.filterValueIDs[doorStyleStep.id][0] === filterValue.id;
        const sizeMatch = sizeStep.selectedValueId && feature.dbFeature.filterValueIDs[sizeStep.id]
          && feature.dbFeature.filterValueIDs[sizeStep.id][0] === sizeStep.selectedValueId;
        return doorStyleMatch && sizeMatch
      });
      if (!existingIdeallyFeature) {
        existingIdeallyFeature = this.state.filteredFeatures.find(feature => {
          const doorStyleMatch = feature.dbFeature.filterValueIDs[doorStyleStep.id]
            && feature.dbFeature.filterValueIDs[doorStyleStep.id][0] === filterValue.id;
          return doorStyleMatch
        });
      }
      // console.log('existingIdeallyFeature', existingIdeallyFeature);
      if (existingIdeallyFeature) {
        const sizeValue = existingIdeallyFeature.dbFeature.filterValueIDs[sizeStep.id][0];
        if (sizeValue && sizeStep.selectedValueId !== sizeValue) {
          sizeStep.selectedValueId = sizeValue;
          const filterGroup = this.props.filterGroups.find(filterGroup => filterGroup.id === sizeStep.id);
          const filterGroupValue = filterGroup && filterGroup.values.find(filterGroupValue => {
            return filterGroupValue.id === sizeValue
          });
          sizeStep.selectedValueName = filterGroupValue ? filterGroupValue.displayText : "";
          sizeStep.selectedItemIsLocked = sizeStep.values.find(val => val.filterValue === sizeValue.itemIsLocked);
        }
      }
    } else if (this.props.activeSubPart.partId === "shower_interior_wall" && !itemIsLocked) {
      if (currentStepFilterName === "DuraBathColor") {
        const patternStep = this.state.availableSteps.find(step => step.filterName === "TilePattern");
        if (!patternStep.selectedValueId) {
          const patternGroup = this.props.filterGroups.find(filterGroup => filterGroup.id === patternStep.id);
          const patternGroupSlabValue = patternGroup.values.find(step => step.value === "Smooth");
          if (patternGroupSlabValue) {
            patternStep.selectedValueId = patternGroupSlabValue.id;
            patternStep.selectedValueName = patternGroupSlabValue.displayText;
            const smoothFilterObject = patternStep.values.find(val => val.filterValue === patternGroupSlabValue.id);
            patternStep.selectedItemIsLocked = smoothFilterObject ? smoothFilterObject.itemIsLocked : false
          }
        }
      }
    }
    this.setState({
      availableSteps,
    }, () => {
      this.tryToClickOnMatchingFiltersItem(itemIsLocked, forceClick)
    });
  };

  setHiddenStateToStep = (availableStep, currentStepFilterName, filterValue, resetStepValues) => {
    const filterValueName = filterValue.value.toLowerCase();
    const stepName = availableStep.filterName.toLowerCase();
    if (this.state.featureWizardStep === 0 && this.props.activeSubPart.partId === "shower_interior_wall") {
      availableStep.hidden =
        (filterValueName !== "durabath" && stepName === "durabathcolor")
        || (filterValueName !== "durabath" && filterValueName !== "tile" && stepName === "tilepattern")
        || (filterValueName !== "acrylic" && stepName === "acrylicpattern")
        || (filterValueName !== "acrylic" && stepName === "acryliccolor")
        || (filterValueName !== "slab" && filterValueName !== "durabath natural stone" && stepName === "slabcolor")
        || (filterValueName !== "tile" && stepName === "tilecolor")
    } else if (this.props.activeSubPart.partId === "vanity_cabinet") {
      if (currentStepFilterName === "DoorStyle") {  // clicked on a door style step value
        const withoutDoorStyle = !NotQCVanityDoorStylesFilters.includes(filterValue.value);
        availableStep.hidden = (withoutDoorStyle && stepName === "material");

        const wizardIsFinished = this.state.availableSteps.filter(step => !step.hidden).every(step => step.selectedValueId);

        if ((stepName === "material" || stepName === "color") && (resetStepValues || !wizardIsFinished)) {
          availableStep.selectedValueId = null;
          availableStep.selectedValueName = "";
          availableStep.selectedItemIsLocked = false;
          // availableStep.needToRefresh = true;
        }
      } else if (resetStepValues && currentStepFilterName === "Size" && stepName !== "size") { // clicked on a Size step value
        availableStep.selectedValueId = null;
        availableStep.selectedValueName = "";
        availableStep.selectedItemIsLocked = false;
      }
    }
    return availableStep
  };

  getPlaceholdersFeatures = () => {
    return this.state.filteredFeatures.filter(feature => feature.dbFeature.displayName.includes("WizardPlaceholder"));
  };

  tryToClickOnMatchingFiltersItem = (itemIsLocked, forceClick) => {
    this.props.setWizardLockedItem(itemIsLocked);

    const selectedFilterObject = this.getCurrentFilterObject();
    // console.log('selectedFilterObject', selectedFilterObject);
    // console.log('=========');
    const arrayOfSelectedKeys = Object.keys(selectedFilterObject);
    const wizardIsFinished = this.state.availableSteps.filter(step => !step.hidden).every(step => step.selectedValueId);
    const filteredFeatures = wizardIsFinished ? this.state.filteredFeatures : this.getPlaceholdersFeatures();

    const foundFeaturesFromFilters = filteredFeatures.filter(feature => {
      const featureFilters = feature.dbFeature.filterValueIDs;
      const arrayOfCurrentKeys = Object.keys(featureFilters);
      // console.log('featureFilters', featureFilters, feature.dbFeature.displayName);
      if (wizardIsFinished) {
        if (Object.keys(selectedFilterObject).every((filterKey) => {
            return featureFilters[filterKey] && featureFilters[filterKey].includes(selectedFilterObject[filterKey])
          })) {
          // console.log('feature', feature);
          return true
        }
        return false
      } else {
        if ((arrayOfCurrentKeys.length === arrayOfSelectedKeys.length) && Object.keys(selectedFilterObject).every((filterKey) => {
            return featureFilters[filterKey] && featureFilters[filterKey][0] === selectedFilterObject[filterKey]
          })) {
          // console.log('feature found', feature);
          return true
        }
        return false
      }
    });
    let foundFeature = null;
    if (Array.isArray(foundFeaturesFromFilters) && foundFeaturesFromFilters.length) {
      if (this.props.activeSubPart.partId === "vanity_cabinet" && foundFeaturesFromFilters.length > 1) {
        foundFeature = foundFeaturesFromFilters.find(feature => feature.metaData["VanityHandle"]);
      }
      if (!foundFeature) {
        foundFeature = foundFeaturesFromFilters[0];
      }
    }
    if (foundFeature && !itemIsLocked) {
      this.props.handleNavigationItemClick({part:foundFeature}, true);
    }
    this.updateStepValues(this.state.availableSteps, forceClick);
  };

  onItemClickDisabled = (filterValue, itemIsLocked, currentStepFilterName) => {
    if (itemIsLocked) {
      this.onItemClick(filterValue, itemIsLocked, currentStepFilterName);
      return;
    }
    // Size is unreachable code since it is always enabled // Alan wants to show them !disabled (26.02.2019)
    const askQuestion = this.props.activeSubPart.partId === "vanity_cabinet"
      && (currentStepFilterName === "DoorStyle" || currentStepFilterName === "Size");

    const message = {
      id: askQuestion ? "messageBox.wizard.itemIsNotAvailableWithQuestion" :  "messageBox.wizard.itemIsNotAvailable",
      filterValueClicked: filterValue.displayText,
      filterName: this.state.availableSteps.filter(step => !step.hidden)[this.state.featureWizardStep].filterName
    };
    const buttons = [{
      text: askQuestion ? "messageBox.buttonNo" : "messageBox.buttonOk",
      color: "blue",
      click: () => {
        this.props.changeMessageBoxState({visible:false});
      }
    }];
    if (askQuestion) {
      buttons.push({
        text: "messageBox.buttonYes",
        color: "green",
        click: () => {
          this.onItemClick(filterValue, itemIsLocked, currentStepFilterName, true);
          this.props.changeMessageBoxState({visible:false});
        }
      })
    }
    this.props.changeMessageBoxState({
      visible: true,
      message,
      buttons
    });
  };

  handleUserLoginClick = (userPopupType = UserPopupTypes.Unlock) => {
    UserLoginButton.handleLoginClick({...this.props, userPopupType});
  };

  exitFeatureWizard = () => {
    if (this.props.isMobile) {
      this.props.exitFeatureWizard(
        this.state.availableSteps,
        this.props.activeSubPart.partId
      )
    } else {
      this.setState({
        mounted: false,
        finishClicked: true
      });
      setTimeout(() => {
        this.props.exitFeatureWizard(
          this.state.availableSteps,
          this.props.activeSubPart.partId
        )
      }, 300);
    }
  };

  render() {
    // console.log('features top', this.state.filteredFeatures);
    // console.log('this.state.availableSteps', this.state.availableSteps);
    const availableSteps = this.state.availableSteps.filter(step => !step.hidden);
    const allStepsCompleted = availableSteps.every(step => step.selectedValueId);
    const interiorShowerWallWizard = this.props.activeSubPart.partId === "shower_interior_wall";
    const itemIsSelected = this.activeItemIsSelected();

    return this.props.isMobile ?
      this.state.showMobileGroups ? (
        <div className="menu-wizard">
          <ul className="wiz-steps">
            {availableSteps.map((wizardStep, wizardStepIndex) => {
              const name = wizardStep.filterName.replace(/ /g,"").toLowerCase();
              return (
                <li className={"wiz-steps__item wiz-steps__item--" + name}
                    onClick={() => this.setFeatureWizardStep(wizardStepIndex)}
                    key={"wizardStepIndex"+wizardStepIndex}>
                  {wizardStep.filterName}
                </li>
              )
            })}
          </ul>
        </div>
      ) : (
        <div className="menu-wizard">
          <div className={"menu-body menu-body--wizard"
          + (interiorShowerWallWizard && !this.props.showerWallWizardGroupsSelected ? " menu-body--selections" : "")}>
            <div className="menu-body__top">
              <SelectionMobileViewSwitchers switchers={[2,4]}/>
              <div className="menu-body__top-subtypes">
                <button className="menu-body__top-button"
                        onClick={this.exitFeatureWizard}>
                  <FormattedMessage id="filterSelection.wizard.exit"/>
                </button>
              </div>
            </div>
            <div className="menu-body__content">
              {availableSteps.length && !this.state.reload ? (
                <FeatureWizardBody currentStep={availableSteps[this.state.featureWizardStep]}
                                   onItemClick={this.onItemClick}
                                   onItemClickDisabled={this.onItemClickDisabled}
                                   handleUserLoginClick={this.handleUserLoginClick}
                                   availableSteps={availableSteps}
                                   featureWizardStep={this.state.featureWizardStep}
                                   isPhoneNumberValidated={this.props.isPhoneNumberValidated}
                                   features={this.state.filteredFeatures}
                                   isMobile={this.props.isMobile}
                                   activeSubPart={this.props.activeSubPart}
                                   showerWallWizardGroupsSelected={this.props.showerWallWizardGroupsSelected}
                                   toggleWizardFilterSelection={this.props.toggleWizardFilterSelection}
                                   exitFeatureWizard={this.exitFeatureWizard}
                                   setFeatureWizardStep={this.setFeatureWizardStep}
                                   filterGroups={this.props.filterGroups}
                                   searchText={this.props.searchText}
                />
              ) : <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>}
            </div>
          </div>
          {!(interiorShowerWallWizard && !this.props.showerWallWizardGroupsSelected) ? (
            <FeatureWizardSteps
              availableSteps={availableSteps}
              featureWizardStep={this.state.featureWizardStep}
              setFeatureWizardStep={this.setFeatureWizardStep}
              exitFeatureWizard={this.exitFeatureWizard}
              isMobile={this.props.isMobile}
              isPhoneNumberValidated={this.props.isPhoneNumberValidated}
              showFeatureWizard={true}
              allStepsCompleted={allStepsCompleted || itemIsSelected}
              finishClicked={this.state.finishClicked}
              getFilterDisplayName={this.props.getFilterDisplayName}
              toggleWizardFilterSelection={this.props.toggleWizardFilterSelection}
            />
          ) : null}
        </div>
      )
    : ( // desktop
      <div className="design-cell design-cell--center">
        <BodyPanel activePart={this.props.activePart}
                   activeSubPart={this.props.activeSubPart}
                   toggleApplyWallsCheckbox={this.props.toggleApplyWallsCheckbox}
                   isWallItem={this.props.isWallItem}
                   handleSubTypeClick={this.props.handleSubTypeClick}
                   useWizard={true}
                   showFeatureWizard={true}
                   availableSteps={availableSteps}
                   featureWizardStep={this.state.featureWizardStep}
                   setFeatureWizardStep={this.setFeatureWizardStep}
                   exitFeatureWizard={this.exitFeatureWizard}
                   getFilterDisplayName={this.props.getFilterDisplayName}
                   showWizardGroupsSelection={interiorShowerWallWizard && !this.props.showerWallWizardGroupsSelected}
                   useFilters={false}
                   toggleWizardFilterSelection={this.props.toggleWizardFilterSelection}
        />
        {availableSteps.length && !this.state.reload ? (
          <FeatureWizardBody currentStep={availableSteps[this.state.featureWizardStep]}
                             onItemClick={this.onItemClick}
                             onItemClickDisabled={this.onItemClickDisabled}
                             handleUserLoginClick={this.handleUserLoginClick}
                             availableSteps={availableSteps}
                             featureWizardStep={this.state.featureWizardStep}
                             isPhoneNumberValidated={this.props.isPhoneNumberValidated}
                             features={this.state.filteredFeatures}
                             isMobile={this.props.isMobile}
                             activeSubPart={this.props.activeSubPart}
                             showerWallWizardGroupsSelected={this.props.showerWallWizardGroupsSelected}
                             toggleWizardFilterSelection={this.props.toggleWizardFilterSelection}
                             exitFeatureWizard={this.exitFeatureWizard}
                             setFeatureWizardStep={this.setFeatureWizardStep}
                             searchText={this.props.searchText}
                             filterGroups={this.props.filterGroups} />
        ) : <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>}
        {interiorShowerWallWizard && !this.props.showerWallWizardGroupsSelected ? null : (
          <div className={"wiz-wrapper" + (this.state.mounted ? " wiz-wrapper--mounted" : "")}>
            <div className="wiz-header">
          <span className="wiz-header__title">
            {availableSteps[this.state.featureWizardStep]
              ? `Select a ${this.props.getFilterDisplayName(availableSteps[this.state.featureWizardStep].filterName, this.props.intl)} for your ${this.props.activeSubPart.partId === "shower_interior_wall" ? "Wall" : "Vanity"}.`
              : null}
          </span>
              <button className="ui-close wiz-header__button"
                      onClick={this.exitFeatureWizard}>Exit wizard</button>
            </div>
            <FeatureWizardSteps
              availableSteps={availableSteps}
              featureWizardStep={this.state.featureWizardStep}
              setFeatureWizardStep={this.setFeatureWizardStep}
              exitFeatureWizard={this.exitFeatureWizard}
              isMobile={this.props.isMobile}
              isPhoneNumberValidated={this.props.isPhoneNumberValidated}
              showFeatureWizard={true}
              getFilterDisplayName={this.props.getFilterDisplayName}
              activeSubPart={this.props.activeSubPart}
              allStepsCompleted={allStepsCompleted || itemIsSelected}
              toggleWizardFilterSelection={this.props.toggleWizardFilterSelection}
            />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  filtersVisible: store.filterState.showFilters,
  filterGroups: store.filterState.filterGroups,
  fabricatorData: store.fabricatorState,
  userIsLoggedIn: store.userState.userIsLoggedIn,
  navigationViewType: store.navigationState.navigationViewType,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
});

const mapDispatchToProps = () => ({});

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeatureWizard)
);
